module.exports = __webpack_public_path__ + "img/hell-store.ea3c6e30.svg";